import { isSameId } from "../../helpers";
export default function (store, { id, join = false }) {
    let { selected } = store.getState();
    if (!store.existsTask(id) || (join && selected.some(i => isSameId(i, id))))
        return;
    if (!join) {
        for (const deselected of selected) {
            if (!isSameId(deselected, id)) {
                store.in.exec("unselect-task", { id: deselected });
            }
        }
        selected = [id];
    }
    else {
        selected.push(id);
    }
    store.updateTask({ id, task: { selected: true } });
    store.setState({ selected });
}
//# sourceMappingURL=select.js.map